import React, { useState, useEffect, useRef, useCallback } from 'react';


const SHOP_LOCATION = {
  lat: 37.77645197799752,
  lng: 30.55438756940552,
  title: "Konumumuz: ISPARTA MERKEZ, Sanayi, 3326. SK NO:16 32200, 32200 merkez/Isparta Sanayi Garanti Bankası ara sokağı",
};



const LEAFLET_CSS_URL = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
const LEAFLET_JS_URL = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';


const LeafletLoader = ({ onScriptLoad }) => {
  useEffect(() => {
    let scriptLoaded = false;
    let styleLoaded = false;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = LEAFLET_CSS_URL;
    link.onload = () => {
      styleLoaded = true;
      if (scriptLoaded) onScriptLoad();
    };
    document.head.appendChild(link);

    const script = document.createElement('script');
    script.src = LEAFLET_JS_URL;
    script.async = true;
    script.defer = true;
    script.onload = () => {
      scriptLoaded = true;
      if (styleLoaded) onScriptLoad();
    };
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(link);
      document.head.removeChild(script);
    };
  }, [onScriptLoad]);

  return null;
};

const MapComponent = () => {
  const mapRef = useRef(null);
  const mapContainerId = "leaflet-map-container";
  const [isLeafletReady, setIsLeafletReady] = useState(false);
  const initializeMap = useCallback(() => {
    if (typeof window.L === 'undefined' || !document.getElementById(mapContainerId)) {
      return;
    }

    try {
      if (mapRef.current) {
        mapRef.current.remove();
      }

      const map = window.L.map(mapContainerId).setView([SHOP_LOCATION.lat, SHOP_LOCATION.lng], 17);
      mapRef.current = map; // Harita nesnesini sakla
      window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        maxZoom: 19,
      }).addTo(map);
      const marker = window.L.marker([SHOP_LOCATION.lat, SHOP_LOCATION.lng], {
      }).addTo(map);


      marker.bindPopup(`
            <div style="font-family: 'Inter', sans-serif; padding: 5px; text-align: center;">
                <strong style="font-size: 1.1em; color: #333;">Gezen Adam Isparta Oto Ekspertiz</strong>
                <br>${SHOP_LOCATION.title}
            </div>
        `).openPopup();

      setIsLeafletReady(true);

    } catch (error) {
      console.error("Harita başlatılırken bir hata oluştu:", error);
    }
  }, []);


  useEffect(() => {
    if (isLeafletReady) {
      initializeMap();
    }
  }, [isLeafletReady, initializeMap]);

  return (
    <div className="flex flex-col items-center justify-center p-4 min-h-screen bg-gray-50 font-sans">
      <h1
        className="text-3xl font-extrabold mb-8 text-gray-900 border-b-4 border-indigo-400 pb-2"
        style={{ fontFamily: 'Onest' }}
      >
        Konumumuz
      </h1>
      <div
        id={mapContainerId}
        className="w-full max-w-4xl border-8 border-indigo-200 shadow-2xl rounded-2xl overflow-hidden mb-6"
        style={{ height: '40vh' }}
      >
        {!isLeafletReady && (
          <div className="flex items-center justify-center w-full h-full bg-gray-200 text-gray-600 animate-pulse" style={{ height: '500px' }}>
            OpenStreetMap Yükleniyor...
          </div>
        )}
      </div>
      <LeafletLoader onScriptLoad={() => initializeMap()} />
    </div>
  );
};
export default MapComponent;